<template>

  <div class="container">
    <!-- Header -->
    <Header></Header>
    <div class="head-img">
      <img :src="headImg">
    </div>
    <!--公司介绍-->
    <div class="introduce">
      <h2>公司介绍</h2>
      <div class="common-border"></div>
      <div class="introduce-container">
        <div class="introduce-text" v-html="aboutInfo.company_introduce"></div>
        <div class="introduce-contant">
          <div class="introduce-item" v-for="(item,index) in introduceImg" :key="index">
            <div class="introduce-item-img"><img :src="item.img"></div>
            <div class="introduce-item-number"><img :src="item.number"></div>
            <span>{{item.text}}</span>
          </div>
        </div>
      </div>
    </div>
    <!--企业文化-->
    <div class="culture">
      <h2>企业文化</h2>
      <div class="common-border"></div>
      <div class="culture-img"><img :src="cultureImg"></div>
    </div>
    <!--产品创新-->
    <div class="product">
      <h2>产品创新</h2>
      <div class="common-border"></div>
      <div class="product-container">
        <div class="product-text" v-html="aboutInfo.technical_text"></div>
        <div class="product-img"><img :src="productImg"></div>
      </div>
    </div>
    <!--用户价值-->
    <div class="user">
      <h2>用户价值</h2>
      <div class="common-border"></div>
      <div class="user-container">
        <div class="user-img"><img :src="userImg"></div>
        <div class="user-text" v-html="aboutInfo.user_value"></div>
      </div>
    </div>
<!--    专业团队-->
    <div class="team">
      <h2>专业团队</h2>
      <div class="common-border"></div>
      <div class="team-container">
        <div class="team-text">{{teamText}}</div>
        <div class="team-img"><img :src="teamImg"></div>
      </div>
    </div>
    <!--    发展规划-->
    <div class="development">
      <h2>发展规划</h2>
      <div class="common-border"></div>
      <div class="development-container">
        <div class="development-text">{{developmentText}}</div>
        <div class="development-img"><img :src="developmentImg"></div>
      </div>
    </div>
    <!-- Footer -->
    <Footer></Footer>
  </div>
</template>

<script>
import axios from 'axios'
var CONFIG = require('@/common/config.js')
var base_url = CONFIG.API_URL.BASE_URL

export default {
  data () {
    return {
      base_url: base_url, // base_url
      aboutInfo: [], // 关于我们信息列表
      productImg: '../../static/images/about/Image 20.png',
      prouductText: '',
      headImg: '../../static/images/about.png',
      userImg: '../../static/images/about/Image 21.png',
      userText: '',
      developmentImg: '../../static/images/about/guiHua.png',
      developmentText: '市场预期：完成以合肥为中心，皖南、皖北为两翼的标杆性项目建设的年度目标，完成全省建设100%覆盖的短期目标，完成全国区域拓展的远期目标。',
      teamImg: '../../static/images/about/team.png',
      teamText: '由多年信息安全从业经验的专家团队创立，专注于大数据科技领域内的技术研发、大数据处理、分析等方面的安全技术创新，以帮助用户应对数字化转型后数据集中应用所带来的大数据安全风险，团队具有多年安全技术公司创业经验',
      cultureImg: '../../static/images/culture.png',
      introduceText: '',
      introduceImg:
          [
            {
              img: '../../static/images/about/Image 4.png',
              number: '../../static/images/about/Image 8.png',
              text: '从业经验'
            },
            {
              img: '../../static/images/about/Image 5.png',
              number: '../../static/images/about/Image 9.png',
              text: '开发沉淀'
            },
            {
              img: '../../static/images/about/Image 7.png',
              number: '../../static/images/about/Image 10.png',
              text: '独立标准'
            },
            {
              img: '../../static/images/about/Image 6.png',
              number: '../../static/images/about/Image 11.png',
              text: '客户积累'
            }
          ]
    }
  },
  created: function () {
    	var that = this

    	// 获取配置信息列表
    	that.getConfigList()
  },
  methods: {

    // 获取配置信息
    getConfigList: function () {
      var that = this
      axios.post(base_url + 'front/getConfigList', {'group': 'company'}).then(function (res) {
        // console.log(res);
        if (res.data.code == 0) {
          var dataList = res.data.result
          var configList = []
          for (var i = 0; i < dataList.length; i++) {
            var itemKey = dataList[i]['itemKey']
            var itemValue = dataList[i]['itemValue']
            configList[itemKey] = itemValue
          }
          // console.log(configList);
          that.aboutInfo = configList

        }
      }).catch(function (err) {
        // console.log(err);
      })
    }

  }
}
</script>

<style scoped>
  @import url("./about.css");
</style>



// WEBPACK FOOTER //
// src/views/about/about.vue